<template>
  <div :class="isOnModeLabelOnLeft? 'input-group w-100' : 'form-group'">
    <div :class="{ 'input-group-prepend' : isOnModeLabelOnLeft }">
      <label
        :for="idComputed"
        :title="titleComputed"
        class="text-truncate"
        :class="{ 'input-group-text' : isOnModeLabelOnLeft }"
        >{{label}} <small v-if="required">*</small>
      </label>
    </div>
    <input ref="autocomplete"
      type="text"
      class="form-control"
      :class="{'is-invalid': v.$error}"
      :readonly="readonly"
      :placeholder="placeholder"
      :id="idComputed"
      :disabled="disabled"
      :name="name"
      @input="$emit('inputLmGooglePlacesAutocomplete', $event.target.value)"
      @focusout="validateOnfocusOutMethod"
      :value="value"
      autocomplete="off"
      :tabindex="tabindex"
    />
    <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  data () {
    return {
      name: new Date().getTime()
    }
  },
  mounted () {
    // eslint-disable-next-line
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete),
      { types: ['geocode'] }
    )
    this.autocomplete.setComponentRestrictions(this.componentRestrictions)
    if (this.shouldAutofocus) {
      this.$refs.autocomplete.focus()
    }
    this.autocomplete.addListener('place_changed', () => {
      this.$emit('placeChanged', this.autocomplete.getPlace())
    })
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    shouldAutofocus: {
      type: Boolean,
      default: false
    },
    componentRestrictions: {
      type: Object,
      default: () => ({ country: 'ar' })
    }
  }
}
</script>
<style>
.pac-container {
  z-index: 9999; /* Establece un valor alto para asegurar que el desplegable esté por encima de otros elementos */
}
</style>
